<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="200"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="lot.no" title="business.label.lot" width="150"/>
        <vxe-column field="location.no" title="business.label.location" width="120"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="command.actualQuantity" title="business.label.quantity"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  name: 'DeliverPrintDetail',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        original: true,
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      },
      orderId: null,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      if (!this.orderId) {
        return this.$message.warning('请选择一行单据再查询明细信息')
      }
      this.loading = true
      const args = {
        ...this.query,
        'order.id': this.orderId
      }
      findAll('shipmentCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(id) {
      if (id) this.orderId = id
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.refresh()
    },
    clear() {
      this.data = []
    }
  }
}
</script>